import { useFilterDisabledSettingsV2 } from "@api";
import type { ISettingValue } from "@bbj-types/setting";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Stack } from "@mui/material";
import { useGlobalContext } from "@root/context";
import type { Dispatch, SetStateAction } from "react";

interface ICandidateStatusFilterProps {
  innerStatus: ISettingValue[];
  setInnerStatus: Dispatch<SetStateAction<ISettingValue[]>>;
}

export const CandidateStatusFilter = ({ innerStatus, setInnerStatus }: ICandidateStatusFilterProps) => {
  const { settingsV2 } = useGlobalContext();

  const settingsStatus = useFilterDisabledSettingsV2(settingsV2.statusCandidate);

  return (
    <Stack>
      {settingsStatus.map((status) => (
        <FormControlLabel
          sx={{ pr: 0.5 }}
          key={status.value}
          label={status.label}
          checked={innerStatus?.some((value) => value.value === status.value) ?? false}
          onChange={() => {
            setInnerStatus((values) => {
              const nValues = [...(values ?? [])];

              const index = nValues.findIndex((value) => value.value === status.value);

              if (index === -1) {
                nValues.push(status);
              } else {
                nValues.splice(index, 1);
              }

              return nValues;
            });
          }}
          control={<Checkbox size="small" sx={{ mr: 0.5, p: 0.5 }} />}
        />
      ))}
    </Stack>
  );
};
